module.exports = __webpack_public_path__ + "img/WHITE_RTS.79b281d3.svg";